export const selectLuckyDip = (state) => state.luckyDipBetslip.luckyDip;
export const selectStake = (state) => state.luckyDipBetslip.stake;
export const selectUsePromocash = (state) => state.luckyDipBetslip.usePromocash;
export const selectStatus = (state) => state.luckyDipBetslip.status;
export const selectSubmitResponse = (state) => state.luckyDipBetslip.submitResponse;
